import { FeatureFlag, Role, type Template } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { FaChartBar, FaList } from 'react-icons/fa';
import type { HocuspocusState } from '../../../components/tiptap/hooks/useHocuspocusProvider';
import { useAppContext } from '../../../hooks/useAppContext';
import { useRole } from '../../../hooks/useRole';
import { TemplateTitleBar } from '../TemplateTitleBar';

interface Props {
  template: Template;
  editor: Editor;
  state: HocuspocusState;
  onTabChange: (tab: 'document' | 'scoring') => void;
}

export const ParticipantDocumentTemplateEditorTitle = (props: Props) => {
  const { template, editor, state, onTabChange } = props;

  const { organization } = useAppContext();

  const hasSupportRole = useRole(Role.Support);
  const hasScoringPermission =
    organization.hasFeature(FeatureFlag.TemplateScoring) || hasSupportRole;

  return (
    <ChakraV3.Stack>
      <TemplateTitleBar template={template} editor={editor} state={state} />
      <ChakraV3.Tabs.Root variant='enclosed' size='md' w='full' defaultValue='document'>
        <ChakraV3.Tabs.List w='full'>
          <ChakraV3.Tabs.Trigger
            onClick={() => onTabChange('document')}
            value='document'
            fontWeight='semibold'
            w='full'
          >
            <ChakraV3.HStack fontSize='sm'>
              <FaList />
              Document
            </ChakraV3.HStack>
          </ChakraV3.Tabs.Trigger>
          <ChakraV3.Tabs.Trigger
            onClick={() => onTabChange('scoring')}
            value='scoring'
            fontWeight='semibold'
            disabled={!hasScoringPermission}
            w='full'
          >
            <ChakraV3.HStack fontSize='sm'>
              <FaChartBar />
              Scoring
            </ChakraV3.HStack>
          </ChakraV3.Tabs.Trigger>
        </ChakraV3.Tabs.List>
      </ChakraV3.Tabs.Root>
    </ChakraV3.Stack>
  );
};
